import { useAnalytics } from '@hotpot-arcade/analytics-client';
import { lazy, Suspense, useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';

const MafiaMatchPage = lazy(() => import('@hotpot-arcade/mafia-client').then((m) => ({ default: m.MafiaMatchPage })));
const GimmeCatGamePage = lazy(() =>
  import('@hotpot-arcade/gimmecat-legacy').then((m) => ({ default: m.GimmeCatGamePage }))
);

const ParteeMatchPage = lazy(() =>
  import('@hotpot-arcade/partee-client').then((m) => ({ default: m.ParteeMatchPage }))
);

const CaketowerMatchPage = lazy(() =>
  import('@hotpot-arcade/caketower-client').then((m) => ({ default: m.CaketowerMatchPage }))
);

const FFChessMatchPage = lazy(() =>
  import('@hotpot-arcade/ffchess-client').then((m) => ({ default: m.FFChessMatchPage }))
);

const CreatorSurveyPage = lazy(() =>
  import('@hotpot-arcade/creator-survey').then((m) => ({ default: m.CreatorSurveyPage }))
);

const WordLadderPage = lazy(() =>
  import('@hotpot-arcade/word-ladder/client').then((m) => ({ default: m.WordLadderPage }))
);

const BubboPage = lazy(() => import('@hotpot-arcade/bubbo').then((m) => ({ default: m.BubboPage })));

const JuiceJamPage = lazy(() => import('@hotpot-arcade/juicejam').then((m) => ({ default: m.JuiceJamPage })));

function useGameId() {
  const { id } = useParams();
  return id || '';
}

export function GamePage() {
  const gameId = useGameId();
  const navigate = useNavigate();
  const { track } = useAnalytics();

  useEffect(() => {
    if (!gameId) navigate('/games');
  }, [gameId, navigate]);

  useEffect(() => {
    if (gameId) {
      track({
        name: 'game_opened',
        props: {
          game_name: gameId,
        },
      });

      return () => {
        track({
          name: 'game_closed',
          props: {
            game_name: gameId,
          },
        });
      };
    }
    return;
  }, [gameId, track]);

  return (
    <div className="w-full h-full flex flex-col">
      <div className="flex-grow w-full h-full">
        <Suspense fallback={<div>loading...</div>}>
          {(() => {
            switch (gameId) {
              case 'mafia':
                return <MafiaMatchPage websocketUrl={import.meta.env.VITE_MAFIA_WEBSOCKET} />;
              case 'gimmecat-legacy':
                return <GimmeCatGamePage />;
              case 'partee':
                return <ParteeMatchPage />;
              case 'caketower':
                return <CaketowerMatchPage />;
              case 'ffchess':
                return <FFChessMatchPage />;
              case 'creator-survey':
                return <CreatorSurveyPage />;
              case 'word-ladder':
                return <WordLadderPage />;
              case 'bubbo':
                return <BubboPage />;
              case 'juicejam':
                return <JuiceJamPage />;
              default:
                return (
                  <div>
                    <p>
                      Game not found{' '}
                      <Link to="/" className="link">
                        Go back
                      </Link>
                    </p>
                  </div>
                );
            }
          })()}
        </Suspense>
      </div>
    </div>
  );
}
